import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-case-group-card',
  templateUrl: './case-group-card.component.html',
  styleUrls: ['./case-group-card.component.css']
})
export class CaseGroupCardComponent implements OnInit {

  constructor() { }

  @Input() caseGroup;
  @Output() deleteAction = new EventEmitter();
  @Output() updateAction = new EventEmitter();
  @Output() editAction = new EventEmitter();
  @Output() selectAction = new EventEmitter();

  ngOnInit() {
    
  }

  onDelete(data) {
    this.deleteAction.emit(data);
  }

  onUpdate(data) {
    this.updateAction.emit(data);

  }

  onEdit(data) {
    this.editAction.emit(data);
  }

  onSelect(data) {
    this.selectAction.emit(data);
  }
}
